<script setup lang="ts">
import { ModalsContainer } from 'vue-final-modal'
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { usePostHogProvider } from '@/composables/usePosthog'
import { useRoute } from 'vue-router'
import { onMounted } from 'vue'
import { onMessage } from 'firebase/messaging'
import { messaging } from './services/firebase'
import Toast from 'primevue/toast'
import { useToast } from 'primevue/usetoast'

const toast = useToast()

const route = useRoute()

usePostHogProvider(import.meta.env.VITE_POSTHOG_KEY, {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  person_profiles: 'identified_only'
})

onMounted(() => {
  onMessage(messaging, (payload) => {
    toast.add({
      summary: payload.notification?.title,
      detail: payload.notification?.body,
      severity: 'info',
      life: 5000
    })
  })
})
</script>

<template>
  <router-view v-slot="{ Component, route }">
    <component :is="Component" :key="route.path" />
  </router-view>
  <VueQueryDevtools :initialIsOpen="false" />
  <ModalsContainer />
</template>
